<template>
  <span>
    <span v-for="(n, key) in Numbers" v-bind:key="key" style="width: 50px; display: inline-block; text-align: center;">{{ n }}</span>
  </span>
</template>
<script>
export default {
  name: 'ShowSuccessResult',
  props: {
    resultNumbers: {
      type: String,
      default: null
    }
  },
  computed: {
    Numbers() {
      if(this.resultNumbers) {
        return this.resultNumbers.split('')
      }else{
        return ['-', '-', '-', '-', '-']
      }
    }
  }
}
</script>
